var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAirplane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 88.889,
    height: 40,
    viewBox: "0 0 88.889 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_355",
    width: 88.889,
    height: 40,
    transform: "translate(98 1544)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_27",
    transform: "translate(-98 -1544)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_plane_takeoff",
    transform: "translate(98 1544)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_356",
    width: 88.889,
    height: 40,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_505",
    transform: "translate(0.022)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_357",
    width: 32.356,
    height: 4.711,
    transform: "translate(5.244 35.289)",
    fill: "#013d53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1481",
    d: "M62.077,9.289c3.044-1.133,5.956-4.889,5.556-6.467-.711-1.467-6.156-3.578-11.289-1.489L40.477,7.778,13.566,0,8.521,1.867,26.632,14.089,14.81,19.667,5.232,16.511.01,18.711,15.321,29.444Z",
    transform: "translate(-0.01)",
    fill: "#013d53"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplane);
export default __webpack_public_path__ + "static/media/airplane.1e63a40a231eceb3949c2b2154d61206.svg";
export { ForwardRef as ReactComponent };